export const NotificationTypes = {
  SCANS: 'scans',
  PT_PROJECTS: 'ptProjects',
};

export const MessageType = {
  SCAN_INITIATED: 'scan_initiated',
  PT_PROJECT_REQUEST: 'pt_project_request',
  POOL_DATA_COMPLETE: 'pool_data_completed',
  PT_PROJECT_STATUS_REQUEST: 'pt_project_status_request',
  PROJECT_SCOPING_STARTED: 'project_scoping_started',
  PROJECT_SCOPING_FINISHED: 'project_scoping_finished',
};

export const ScansFilterMessageTypes = [MessageType.SCAN_INITIATED, MessageType.POOL_DATA_COMPLETE];
export const ptProjectFilterMessageTypes = [MessageType.PT_PROJECT_STATUS_REQUEST, MessageType.PT_PROJECT_REQUEST, MessageType.PROJECT_SCOPING_STARTED, MessageType.PROJECT_SCOPING_FINISHED];
